module.exports = __webpack_public_path__ + "static/img/1.6df6674.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/contact/1.jpg
// module id = b58r
// module chunks = 1